import React from 'react';
import { Workflow } from './types';
import { Tabs, TabsList, TabsTrigger } from '../../common/ui/Tabs';

export function WorkflowFilters({
  workflows,
  handleWorkflowChange,
  activeWorkflow,
  activeWorkflowDocumentsCount,
}: {
  workflows: Workflow[],
  handleWorkflowChange: (workflowName: string) => void,
  activeWorkflow: string,
  activeWorkflowDocumentsCount: number,
}) {
  const workflowIsActive = (workflowName: string) => workflowName === activeWorkflow;
  return (
    <Tabs defaultValue={activeWorkflow}>
      <TabsList className="w-100">
        {workflows.map((workflow) => (
          <TabsTrigger
            key={workflow.name}
            value={workflow.name}
            onClick={() => handleWorkflowChange(workflow.name)}
          >
            {workflow.displayName}
            {workflowIsActive(workflow.name) && ` (${activeWorkflowDocumentsCount})`}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
